import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function AboutSection() {
  const { t } = useTranslation();

  return (
    <section id="about" className="py-20 md:py-28 px-6 md:px-10 lg:px-16 bg-background-50">
      <div className="max-w-[1280px] mx-auto">
        <div className="mb-14">
          <p className="text-xs font-semibold uppercase tracking-widest text-foreground-400 mb-4">
            {t('about.label')}
          </p>
          <h2 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-foreground-950 leading-tight max-w-3xl">
            {t('about.title1')} <span className="italic text-primary-500">{t('about.title2')}</span>
            <br />
            {t('about.title3')}
          </h2>
          <p className="text-sm text-foreground-500 mt-6 max-w-xl leading-relaxed">
            {t('about.description')}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
          <div className="bg-accent-500 rounded-2xl p-8 md:p-10 relative overflow-hidden group cursor-pointer">
            <div className="absolute top-6 right-6 w-10 h-10 flex items-center justify-center rounded-full bg-white/20 text-white">
              <i className="ri-arrow-right-up-line text-lg" />
            </div>
            <div className="font-heading text-7xl md:text-8xl font-bold text-white mb-4">
              {t('about.stats1.number')}<span className="text-4xl">{t('about.stats1.suffix')}</span>
            </div>
            <p className="text-sm text-white/90 leading-relaxed mb-1">
              {t('about.stats1.description')}
            </p>
            <p className="font-heading italic text-white/70 text-sm mt-6">
              {t('about.stats1.tagline')}
            </p>
          </div>

          <div className="bg-primary-800 rounded-2xl p-8 md:p-10 relative overflow-hidden group cursor-pointer">
            <div className="absolute top-6 right-6 w-10 h-10 flex items-center justify-center rounded-full bg-white/20 text-white">
              <i className="ri-arrow-right-up-line text-lg" />
            </div>
            <div className="font-heading text-7xl md:text-8xl font-bold text-white mb-4">
              {t('about.stats2.number')}<span className="text-4xl">{t('about.stats2.suffix')}</span>
            </div>
            <p className="text-sm text-foreground-200 leading-relaxed max-w-sm">
              {t('about.stats2.description')}
            </p>
          </div>
        </div>

        <div className="mt-10 text-center">
          <Link
            to="/about"
            className="inline-flex items-center gap-2 px-6 py-3 text-sm font-semibold text-primary-500 hover:text-primary-600 border border-primary-200 hover:border-primary-300 rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            {t('home.viewAbout')}
            <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </div>
    </section>
  );
}